import { render, staticRenderFns } from "./QPageDataTable.vue?vue&type=template&id=50d80d50&scoped=true&"
import script from "./QPageDataTable.vue?vue&type=script&lang=js&"
export * from "./QPageDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QPageDataTable.vue?vue&type=style&index=0&id=50d80d50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d80d50",
  null
  
)

export default component.exports